/* eslint-disable @typescript-eslint/no-explicit-any */

export const cleanObject_id: any = (value: any) => {
	if (value === null || value === undefined) {
		return value;
	} else if (Array.isArray(value)) {
		return value.map((v) => cleanObject_id(v));
	} else if (typeof value === 'object') {
		const obj: any = {};
		
		// First, check if the object has _id but no id
		const hasUnderscoreId = '_id' in value;
		const hasId = 'id' in value;
		
		Object.keys(value).forEach((key) => {
			if (key === '_id') {
				// Convert _id to id only if there's no existing id field
				if (!hasId) {
					obj['id'] = cleanObject_id(value[key]);
				}
				// Don't include _id in the result
			} else {
				obj[key] = cleanObject_id(value[key]);
			}
		});
		return obj;
	}
	return value;
};
